export default __webpack_public_path__ + "marker-black.png";